import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { isEmpty } from 'lodash';

import { Box, Loader } from '@qwealth/qcore';

import { useAppSelector } from 'data/store';
import ComplianceChecklistCard from './Checklist/ComplianceChecklistCard';
import ComplianceTasksCard from './Tasks/ComplianceTasksCard';
import { useAppDispatch } from 'data/store';
import {
  getClientsComplianceReview,
  getComplianceChecklistsAndNotesForClient,
  resetComplianceContactRelatedInfo,
  setSelectedClientComplianceReview,
} from 'data/actions/compliance';
import { selectClientsComplianceReview, selectComplianceIsLoading } from 'data/selectors/compliance';
import { complianceRoute } from 'data/refData/compliance';

const ComplianceContactPage: FC = (): JSX.Element => {
  const selectedContactQID = useParams().contactQID;
  const clientsToReview = useAppSelector(selectClientsComplianceReview);
  const isLoading = useAppSelector(selectComplianceIsLoading);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isEmpty(clientsToReview)) {
      (async () => {
        await dispatch(getClientsComplianceReview());
      })();
    }
  }, [clientsToReview, dispatch]);

  useEffect(() => {
    if (selectedContactQID) {
      (async () => {
        await dispatch(getComplianceChecklistsAndNotesForClient(selectedContactQID));
      })();
    }
  }, [selectedContactQID, dispatch]);

  useEffect(() => {
    if (selectedContactQID && !isEmpty(clientsToReview)) {
      (async () => {
        await dispatch(setSelectedClientComplianceReview(selectedContactQID));
      })();
    }
  }, [selectedContactQID, clientsToReview, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetComplianceContactRelatedInfo());
    };
  }, [dispatch]);

  return (
    <>
      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <Loader />
        </Box>
      ) : (
        <Box display="flex" flexDirection="row" gap="large">
          <ComplianceChecklistCard clickBack={() => navigate(`/${complianceRoute.path}`)} />
          <ComplianceTasksCard />
        </Box>
      )}
    </>
  );
};

export default ComplianceContactPage;
